module.exports = __webpack_public_path__ + "img/out_in_yidong.ebdc3485.jpg";